export default __webpack_public_path__ + "static/media/courseProfileMale.cfa05d0b.svg";